module.exports = __webpack_public_path__ + "img/2.70b46a3d.png";